import "./pitch.css";
import { PitchIcon, type PitchIconName } from "./PitchIcons";
import { PitchTile } from "./PitchTile";

export interface BuiltTile {
  label: string;
  title: string;
  body: string;
  icons: PitchIconName[];
  chip?: string;
  tone?: "plain" | "accent";
}

export const BUILT_TILES: BuiltTile[] = [
  {
    label: "Today",
    title: "Live in production",
    body: "Live in production at a hospital department in Singapore.",
    icons: ["check"],
  },
  {
    label: "Daily",
    title: "Every day",
    body: "Leads on the laptop. Members on the phone and in Telegram.",
    icons: ["planner", "member", "chat"],
    tone: "accent",
  },
  {
    label: "This month",
    title: "Every seat filled",
    body: "October 2026 roster: every on-call seat filled, every night.",
    icons: ["record"],
  },
];

export interface BuiltTilesProps {
  tiles?: BuiltTile[];
}

/** `sofar.html`: what has been built so far, as three tiles. */
export function BuiltTiles({ tiles = BUILT_TILES }: BuiltTilesProps) {
  return (
    <div className="pitch pitch-built">
      <div className="pitch-built-row">
        {tiles.map((t) => (
          <PitchTile key={t.title} label={t.label} title={t.title} tone={t.tone}>
            <div className="pitch-icon-row">
              {t.icons.map((n) => (
                <PitchIcon key={n} name={n} size={t.icons.length > 1 ? 56 : 64} />
              ))}
            </div>
            <p className="pitch-text">{t.body}</p>
            {t.chip ? <p className="pitch-chip">{t.chip}</p> : null}
          </PitchTile>
        ))}
      </div>
    </div>
  );
}
